/** русское множественное число: 1 сфера, 2 сферы, 5 сфер */
export function plural(n, a, b, c) {
    const m = n % 100;
    const d = n % 10;
    if (m > 10 && m < 20)
        return c;
    if (d > 1 && d < 5)
        return b;
    if (d === 1)
        return a;
    return c;
}
//# sourceMappingURL=plural.js.map